import { UseServer } from '@stadionhq-v3/base-ui';
import { SnippetCardProps } from '@stadionhq-v3/football-ui';
import { CleanContentful } from '@stadionhq-v3/clean-contentful';
import { Snippet } from '@graphql/index';
import { ContentfulImage } from '@stadionhq-v3/contentful-ui';
import { DocumentLinks, Theme, ThemeId } from '@stadionhq-v3/core';
import { Locale } from '@core/constants/locales.constants';
import ContentfulRichTextRenderer from '@components/helpers/contentful-rich-text-render';
import { ArrowRight } from '@components/icons';

export type SnippetCardSettings = {
  publishDateFormat?: string;
  locale: Locale;
};

const snippetCardTransform = (
  {
    publishedDate,
    snippetTitle,
    snippetCopy,
    theme,
    image,
    links,
  }: CleanContentful<Snippet>,
  { locale, publishDateFormat }: SnippetCardSettings
): SnippetCardProps => {
  const isDark = () => {
    switch (theme?.themeId as ThemeId) {
      case 'colourTheme3':
      case 'colourTheme4':
      case 'colourTheme5':
      case 'colourTheme6':
        return true;
      default:
        return false;
    }
  };

  return {
    publishDate: {
      date: new Date(publishedDate),
      format: publishDateFormat || "DD MMM 'YY",
      locale,
    },
    title: snippetTitle ?? undefined,
    copy: (
      <UseServer>
        <ContentfulRichTextRenderer
          document={{
            json: snippetCopy?.json,
            links: snippetCopy?.links as DocumentLinks,
          }}
          theme={(theme as Theme) || undefined}
        />
      </UseServer>
    ),
    links:
      links && links.length > 0
        ? links.map((link, index) => ({
            ...link,
            text: link.title || '',
            iconAfter: <ArrowRight />,
            size: 'large',
            variant: index === 0 ? 'primary' : 'text-button',
          }))
        : undefined,
    image: image ? <ContentfulImage {...image} /> : undefined,
    theme: {
      themeId: theme?.themeId as ThemeId,
      title: theme?.title as string,
    },
    onDark: isDark(),
  };
};

export default snippetCardTransform;
